// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2295":"css/admin-app.6773","6054":"css/app.6773"}[chunkId] + ".css";
};